import apiFetch from '../apiFetch'

export default function (token, permissionCode) {
  return apiFetch({ endPoint: 'organizedUnit/TreeByPermission?code=' + permissionCode, method: 'GET', body: null, token: token })
}
